// Copyright 2025-2026 Florian Gallon. All Rights reserved.
// Inline SVG (fill="currentColor") so the lockup takes the CSS `color` of its
// container — no filter hacks, no bundler URL resolution.
import { ReactComponent as Lockup } from './lockup-horizontal.svg';

export default function LandingLogo({ className }) {
  return <Lockup className={`dbk-logo ${className || ''}`.trim()} role="img" aria-label="Digi-Bakery" />;
}
